<template>
  <v-container class="px-5 col-12">
    <v-data-iterator
      :items="items"
      :loading="loading"
      item-key="project"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <h2>
            Deploy Content
          </h2>
          <v-btn
            icon
            @click="load"
            :loading="loading"
            :disabled="loading"
            class="ml-2"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-row>
      </template>
      <template v-slot:default="{ items }">
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.project"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
              <v-card-title>
                <h4>{{ item.project }}</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-list
                dense
              >
                <v-list-item v-for="env of item.env" :key="env + item.project">
                  <v-list-item-content class="text-uppercase">{{ env }}</v-list-item-content>
                  <v-list-item-content class="align-end">
                    <v-row class="ma-0">
                      <v-spacer />
                      <v-btn
                        color="success"
                        @click="deploy(item.entity_id, env, item.project)"
                        :loading="loading"
                        :disabled="loading"
                      >
                        Deploy
                      </v-btn>
                      <history class="ml-2" handler="deploy" :entity_id="item.entity_id" :env="env" icon="history" title="Deploy History" />
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<style>

</style>

<script>

  import { API } from '@/utils/api'
  import CMSDeployHistory from '@/components/helper/CMSDeployHistory'

  export default {

    components: {
      History: CMSDeployHistory
    },

    data: () => ({
      loading: false,
      headers: [
        { text: '#', value: 'row_num', sortable: false },
        { text: 'Env', value: 'key' },
        { text: '', value: 'action' },
      ],
      items: []
    }),

    mounted () {
      this.load()
    },

    methods: {
      load () {
        this.loading = true
        API.call('/cms/deploy/list.json', {}).then(resp => {
          this.items = resp.data
        }).finally(() => {
          this.loading = false
        })
      },
      deploy (entity_id, env, project) {
        this.loading = true
        API.call('/cms/deploy/deploy.json', {
          entity_id, env
        }).then(r => {
          this.$notification.message = r?.data?.message || `Deploy: ${project} - ${env.toUpperCase()}`
          this.$notification.show = true
          this.$notification.type = 'success'
        }).finally(() => {
          this.loading = false
        })
      },
    },

  }
</script>


